import { Container, Row, Col, Button, Form } from "react-bootstrap";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import icon1 from "../../../images/create_entity_account_icon1.png";
import icon2 from "../../../images/create_entity_account_icon2.png";
import icon3 from "../../../images/create_entity_account_icon3.png";
import icon4 from "../../../images/create_entity_account_icon4.png";
import arrow_left from "../../../images/arrow-left.png";
import { Link, useParams } from "react-router-dom";
import BackButton from "../../Includes/BackButtonEntityAccount";
import { useState, useEffect } from "react";
import countriesData from "../../../data/countries.json";
import config from "../../../config";
import axios, { AxiosError } from "axios";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setEmail,
  setwizardPageNumber,
  setEmailVerify,
  setUserID,
  setEntityAccountUserDetails,
  setEntityAccountBusinessDetails,
  setBusinessAddressDetails,
  setPhysicalBusinessAddressDetails,
  setAccountUseDetails,
  setUploadDocumentDetails,
  setwizardPageName,
  setInvites,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError, notifySuccess } from "MyComponents/Toaster";
import SelectSearch, { useSelect } from "react-select-search";
import { Dropdown } from "primereact/dropdown";
import Spinner from "react-bootstrap/Spinner";
import Spacer from "MyComponents/UI/Spacer";
import { fetchAllEntityAccountDetails, getUserData } from "Utils/user";
import Loader from "MyComponents/UI/Loader";
import { updateEntityKycDraftStep } from "Utils/entityKycDraft";
import { useTranslation } from "react-i18next";

interface Props { }
interface FormData {
  firstName: string;
  lastName: string;
  entityUserName: string;
  entityBusinessName: string;
  country: string;
}

const CreateEntityAccount: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { t } = useTranslation();
  const { handleSubmit } = props;
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  let email = useSelector((state: RootState) => state.entityAccount.email);
  const authEmail = useSelector((state: RootState) => state.auth.email);
  const userID = useSelector((state: RootState) => state.entityAccount.userID);
  const entityAccountUserDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountUserDetails
  );
  console.log("entityAccountUserDetails", entityAccountUserDetails);
  const [selectedCountry, setSelectedCountry] = useState(
    entityAccountUserDetails?.country
  );
  console.log("selectedCountry", selectedCountry);
  const [countryValidation, setCountryValidation] = useState(false);
  const options = countriesData.map((country) => ({
    name: country.name,
    image: country.image,
  }));
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userId } = useParams<{ userId?: string }>();
  const theme = useSelector((state: RootState) => state.theme.theme);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    dispatch(setwizardPageName("createEntityAccount"));
  }, [dispatch]);

  useEffect(() => {
    if (entityAccountUserDetails?.country) {
      setSelectedCountry(entityAccountUserDetails.country);
    }
  }, [entityAccountUserDetails]);

  const startLoading = () => {
    setLoading(true);
  };

  const countryOptionTemplate = (option: any) => {
    return (
      <div className="flex align-items-center">
        {(option.image || selectedCountry.image) && (
          <img
            src={option.image || selectedCountry.image}
            alt={option.name}
            style={{ width: "20px", marginRight: "5px" }}
          />
        )}
        {option.name || selectedCountry.name}
      </div>
    );
  };

  const countryValueTemplate = (option: any, props: any) => {
    console.log("option", option);

    return (
      <div className="flex align-items-center">
        {option && (
          <>
            <img
              alt={option.name}
              src={option.image || entityAccountUserDetails?.country?.image}
              style={{ width: "20px", marginRight: "5px" }}
            />
            {option.name}
          </>
        )}
        {!option && selectedCountry && (
          <>
            <img
              alt={entityAccountUserDetails?.country?.name}
              src={entityAccountUserDetails?.country?.image}
              style={{ width: "20px", marginRight: "5px" }}
            />
            {selectedCountry}
          </>
        )}
        {!option && !selectedCountry && <span>{props.placeholder}</span>}
      </div>
    );
  };

  const validateFirstName = (value: any) => {
    console.log("validateFirstName received value:", value);
    if (!value || (typeof value === 'string' && !value.trim())) {
      return "First Name is required";
    }
  };

  const validateLastName = (value: any) => {
    console.log("validateLastName received value:", value);
    if (!value || (typeof value === 'string' && !value.trim())) {
      return "Last Name is required";
    }
  };

  const validateBussinessName = (value: any) => {
    console.log("validateBussinessName received value:", value);
    if (!value || (typeof value === 'string' && !value.trim())) {
      return "Business Name is required";
    }
  };

  const submitForm = async (formValues: FormData) => {
  setIsSubmitted(true);

  const userDetailsObject = {
    ...entityAccountUserDetails,
    firstName: formValues.firstName,
    lastName: formValues.lastName,
    entityUserName: formValues.entityUserName || email || authEmail,
    entityBusinessName: formValues.entityBusinessName,
    country: selectedCountry,
  };

  dispatch(setEntityAccountUserDetails(userDetailsObject));

  if (!selectedCountry) {
    setCountryValidation(true);
    return;
  }

  const currentEmail = email || authEmail;

  if (!currentEmail) {
    setDataLoading(true);
    try {
      const _userData = await getUserData(userId || '');
      if (_userData?.userName) {
        dispatch(setEmail(_userData.userName));
        await proceedWithSubmission(formValues, _userData.userName);
      } else {
        notifyError("Email is required but not found.");
        setLoading(false);
      }
    } catch (err) {
      notifyError("Failed to fetch user context.");
      setLoading(false);
    } finally {
      setDataLoading(false);
    }
    return;
  }

  await proceedWithSubmission(formValues, currentEmail);
  };

  const proceedWithSubmission = async (formValues: FormData, finalEmail: string) => {
    startLoading();
    const { firstName, lastName, entityUserName, entityBusinessName } = formValues;
    const country = selectedCountry;

    const userDetailsObject = {
      ...entityAccountUserDetails,
      firstName,
      lastName,
      entityUserName: entityUserName || finalEmail,
      entityBusinessName,
      country,
    };

    dispatch(setEntityAccountUserDetails(userDetailsObject));

    try {
      const userIDToUse = userID || userId || '';
      await updateEntityKycDraftStep(userIDToUse, 'EntityAccountUser', userDetailsObject);
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);
    } catch (error) {
      console.error("Draft update error:", error);
      notifyError("Failed to save progress. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {dataLoading ? (
        <Loader message={t('common.fetching_data')} size="sm" />
      ) : (
        <Container fluid>
          <Row className="">
            <Col md={6}>
              <div>
                <p className="text-primary fw-bold fs-5">
                  {t('register.create_entity_title')}
                </p>
                <p className="text-secondary small">
                  {t('kyc.entity_hero_desc')}
                </p>
                <Row className="justify-content-start">
                  <Col md={12}>
                    <Form noValidate={true} onSubmit={handleSubmit(submitForm)}>
                      <Row>
                        <Col md={6} className="">
                          <label className="form-label fw-bold ">
                            {t('kyc.legal_first_name')}
                          </label>
                          <Field
                            name="firstName"
                            type="text"
                            component={renderField}
                            className="form-control rounded-5"
                            placeholder={t('kyc.type_first_name')}
                            id="firstName"
                            validate={validateFirstName}
                          />
                        </Col>
                        <Col md={6} className="">
                          <label className="form-label fw-bold ">
                            {t('kyc.legal_last_name')}
                          </label>
                          <Field
                            name="lastName"
                            type="text"
                            component={renderField}
                            className="form-control rounded-5"
                            placeholder={t('kyc.type_last_name')}
                            id="lastName"
                            validate={validateLastName}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="mt-3">
                          <label className="form-label fw-bold ">
                            {t('kyc.business_name')}
                          </label>
                          <Field
                            name="entityBusinessName"
                            type="text"
                            component={renderField}
                            className="form-control rounded-5"
                            placeholder={t('kyc.type_business_name')}
                            id="entityBusinessName"
                            validate={validateBussinessName}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="mt-3">
                          <label className="form-label fw-bold ">
                            {t('kyc.select_country_residence')}
                          </label>
                          <br />

                          <Dropdown
                            value={selectedCountry}
                            onChange={(e) => {
                              setSelectedCountry(e.value);
                              setCountryValidation(false);
                            }}
                            options={options}
                            optionLabel="name"
                            placeholder={t('ui.country_placeholder')}
                            filter
                            valueTemplate={countryValueTemplate}
                            itemTemplate={countryOptionTemplate}
                            className="w-full md:w-14rem w-100  p-2 text-start px-3  border rounded-5"
                          />
                          <div
                            id="country_validation"
                            className={countryValidation ? "" : "d-none"}
                          >
                            <small className="text-danger">
                              {t('ui.country_required')}
                            </small>
                          </div>
                        </Col>
                      </Row>
                      <Button
                        variant="primary"
                        type="submit"
                        className="btn btn-primary rounded-5 mt-4"
                        disabled={loading && isSubmitted}
                      >
                        {loading && isSubmitted && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="mx-2"
                          />
                        )}
                        <span>{t('common.save_continue')}</span>
                      </Button>{" "}
                    </Form>
                  </Col>
                </Row>

                <Row className="justify-content-center">
                  <Col md={12} className=" py-4 px-0 text-secondary small">
                    {t('kyc.entity_legal_disclaimer')}
                    <Link className="text-primary" to={"/user-agreement"} target="_blank">
                      {" "}
                      {t('kyc.entity_user_agreement')}
                    </Link>{" "}
                    ,
                    <Link className="text-primary" to={"/privacy-policy"} target="_blank">
                      {" "}
                      {t('common.privacy_policy')}
                    </Link>
                    ,{" "}
                    <Link className="text-primary" to={"/acceptable-use-policy"} target="_blank">
                      {t('kyc.entity_acceptable_use')}
                    </Link>
                    ,{" "}
                    <Link className="text-primary" to={"/cookies-policy"} target="_blank">
                      {t('kyc.entity_cookie_policy')}
                    </Link>
                    ,{" "}
                    <Link className="text-primary" to={"/e-sign-consent"} target="_blank">
                      {t('kyc.entity_esign')}
                    </Link>{" "}
                    {t('common.and')}{" "}
                    <Link className="text-primary" to={"/risk-factors"} target="_blank">
                      {t('kyc.entity_risk_factors')}
                    </Link>
                    .<br /> <br />
                    {t('kyc.entity_marketing_agree')}
                    <br />
                    <br />
                    <br />
                    <br />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={6} className={`${theme === "dark" && "bg-black"} bg-sky d-none d-md-block px-5 py-4`}>
              <Row>
                <Col md={12} className="    ">
                  <h4 className=" ">{t('kyc.entity_features_title')}</h4>
                </Col>
              </Row>

              <Row className=" justify-content-center">
                <Col
                  md={5}
                  className={`${theme === "dark" ? "bg-black" : "bg-white"
                    } mt-3 rounded-4 `}
                >
                  <img className=" mt-3 ms-2 " src={icon1} />

                  <span className="row mt-3 ms-2 text-secondary small ">
                    {t('kyc.entity_feature1')}
                  </span>
                </Col>

                <Col
                  md={5}
                  className={`${theme === "dark" ? "bg-black" : "bg-white"
                    }  mt-3 ms-3 rounded-4 `}
                >
                  <Row>
                    <Col md={6} className="">
                      <img className="row mt-3 ms-2 " src={icon2} />
                    </Col>
                    <Col md={6} className=" mt-4 py-2">
                      <Link to={"/risk-factors"} target="_blank">
                        <span className="text-primary">
                          {t('kyc.terms_apply')}
                          <i className="fa-solid fa-arrow-right ms-2"></i>
                        </span>
                      </Link>
                    </Col>
                  </Row>
                  <span className="row mt-3 ms-2 mb-4 text-secondary small">
                    {t('kyc.entity_feature2')}
                  </span>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col
                  md={5}
                  className={`${theme === "dark" ? "bg-black" : "bg-white"
                    } mt-3 rounded-4 `}
                >
                  <img className="row mt-3 ms-2 " src={icon3} />

                  <p className="row mt-3 ms-2 mb-4 text-secondary small">
                    {t('kyc.entity_feature3')}
                  </p>
                </Col>

                <Col
                  md={5}
                  className={`${theme === "dark" ? "bg-black" : "bg-white"
                    } mt-3 ms-3 rounded-4 `}
                >
                  <img className="row mt-3 ms-2 " src={icon4} />

                  <span className="row mt-3 ms-2 mb-4 text-secondary small">
                    {t('kyc.entity_feature4')}
                  </span>
                </Col>
              </Row>
              <br />
              <br />
              <Row>
                <Col md={12} className="">
                  <h4 className=" ps-2">
                    {t('kyc.entity_features_title')}
                  </h4>
                  <p className="text-secondary small">
                    {t('kyc.entity_available_desc')}
                  </p>
                </Col>
              </Row>
              <Row className=" justify-content-center">
                <Col
                  md={5}
                  className={`${theme === "dark" ? "bg-black" : "bg-white"
                    }  mt-3 mb-2 rounded-4 `}
                >
                  <Row>
                    <Col md={6} className="">
                      <img className="row mt-3 ms-2 " src={icon2} />
                    </Col>
                    <Col md={6} className=" mt-4 py-2">
                      <Link to={"/global-availability"} target="_blank">
                        <span className="text-primary">
                          {t('common.learn_more')}
                          <i className="fa-solid fa-arrow-right ms-2"></i>
                        </span>
                      </Link>
                    </Col>
                  </Row>
                  <span className="row mt-3 ms-2 mb-4 text-secondary small ">
                    {t('kyc.entity_eligible_countries')}
                  </span>
                </Col>
                <Col
                  md={5}
                  className={`${theme === "dark" ? "bg-black" : "bg-white"
                    } mt-3 mb-2 ms-3 rounded-4 `}
                >
                  <Row>
                    <Col md={6} className="">
                      <img className="row mt-3 ms-2 " src={icon2} />
                    </Col>
                    <Col md={6} className=" mt-4 py-2">
                      <Link to={"/global-availability"} target="_blank">
                        <span className="text-primary">
                          {t('common.learn_more')}
                          <i className="fa-solid fa-arrow-right ms-2"></i>
                        </span>
                      </Link>
                    </Col>
                  </Row>
                  <span className="row mt-3 ms-2 mb-4 text-secondary small">
                    {t('kyc.entity_eligible_types')}
                  </span>
                </Col>
              </Row>
              <br />
              <br />
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  initialValues: {
    firstName: state.entityAccount.entityAccountUserDetails.firstName || "",
    lastName: state.entityAccount.entityAccountUserDetails.lastName || "",
    entityUserName: state.entityAccount.entityAccountUserDetails.entityUserName || "",
    entityBusinessName: state.entityAccount.entityAccountUserDetails.entityBusinessName || "",
    country: state.entityAccount.entityAccountUserDetails.country || "",
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "entityWizard",
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(CreateEntityAccount);

export default connect(mapStateToProps)(form);
